import { render, staticRenderFns } from "./NuevoUsuario.vue?vue&type=template&id=0ec6164b&"
import script from "./NuevoUsuario.vue?vue&type=script&lang=js&"
export * from "./NuevoUsuario.vue?vue&type=script&lang=js&"
import style0 from "./NuevoUsuario.vue?vue&type=style&index=0&id=0ec6164b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports